import { render, staticRenderFns } from "./AdsContent.vue?vue&type=template&id=6989f802&"
import script from "./AdsContent.vue?vue&type=script&lang=js&"
export * from "./AdsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports